import { UnifiedAuthViewModel } from '@apis/model/unifiedAuth/UnifiedAuthViewModel';
import { toCaptchaViewModel, toOtpViewModel } from '@apis/responseTransformer';
import { UnifiedAuthResponse } from '@ul/api';

export const toUnifiedAuthViewModel = (unifiedResponse: UnifiedAuthResponse): UnifiedAuthViewModel => {
    const { success, responseCode, downStreamServiceFailure, token, canUsePassword } = unifiedResponse;
    return {
        responseCode,
        success,
        downStreamServiceFailure,
        token,
        canUsePassword,
        captchaViewModel: toCaptchaViewModel(unifiedResponse),
        otpViewModel: toOtpViewModel(unifiedResponse),
    };
};
